'use strict';

// Owns one view's desired point set independently from whether that view is
// currently presenting realtime data. subscribePoint returns an unsubscribe.
function createLiveInterest(subscribePoint, callback) {
  const desired = new Set();
  const active = new Map();
  let visible = true;
  let destroyed = false;

  const deactivate = (tag) => {
    const drop = active.get(tag);
    if (drop) drop();
    active.delete(tag);
  };
  const activate = (tag) => {
    if (!destroyed && visible && !active.has(tag)) {
      active.set(tag, subscribePoint(tag, callback));
    }
  };
  const replace = (tags) => {
    if (destroyed) return;
    const next = new Set((tags || []).map(String).filter(Boolean));
    [...desired].forEach((tag) => { if (!next.has(tag)) { desired.delete(tag); deactivate(tag); } });
    next.forEach((tag) => { desired.add(tag); activate(tag); });
  };
  const setVisible = (next) => {
    if (destroyed || visible === Boolean(next)) return;
    visible = Boolean(next);
    if (!visible) [...active.keys()].forEach(deactivate);
    else desired.forEach(activate);
  };
  const destroy = () => {
    if (destroyed) return;
    destroyed = true;
    [...active.keys()].forEach(deactivate);
    desired.clear();
  };
  return {replace, setVisible, destroy,
    desired: () => [...desired], active: () => [...active.keys()]};
}

export default createLiveInterest;
